import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-pile-saver',
  templateUrl: './pile-saver.page.html',
  styleUrls: ['./pile-saver.page.scss'],
})
export class PileSaverPage implements OnInit {
  @Input() original:any;
  @Input() data:any;
  constructor(public modalController: ModalController) { }

  get changed():any[]{
    if(!this.original) return [];
    if(!this.data) return [];
    const {original,data}= this;
    const changes = [];
    const frMap = {
      road: 'chemin',
      team: 'equipe',
      operation:'operation',
      status:'statut',
      created: 'créée',
      modified: 'modifiée',
      transported: 'transportée'
    };
    Object.keys(frMap).forEach( (flatKey:string)=>{
      let text = frMap[flatKey];
      if(data[flatKey] != original[flatKey]){
        let value = data[flatKey];
        let old = original[flatKey];
        if(value && ['created','modified','transported'].includes(flatKey)){
          value = value.toISOString().replace(/T.+/,'');
          if(old){
            old = old.toISOString().replace(/T.+/,'');
          }
        }
        if(!old){
          old = '      ';
        }
        changes.push({text:text,attr: flatKey, old:old, new:value});
      }
    });
    if(data.logLength && data.logLength != original.measures?.logLength){
      changes.push({text:'L. Bille', attr: 'logLength', old: original.measures?.logLength, new: data.logLength });
    }
    if(data.length && data.length != original.measures?.length){
      changes.push({text:'L. Pile', attr: 'length', old: original.measures?.length, new: data.length });
    }
    let oldH:any;
    if(!original.measures || !original.measures.heights || (original.measures.heights && !original.measures.heights.length)){
      oldH = '      ';
    }else{
      oldH = original.measures?.heights.reduce( (t:number,n:number)=>{ return t + n},0)/original.measures?.heights.length;
      oldH = Number(oldH).toFixed(2);
    }
    if(data.height && data.logLength != original.measures?.logLength){
      changes.push({text:'H. Moy.', attr: 'height', old: oldH, new: data.height });
    }
    if(data.essence && (data.essence != original.essenceCode)){
      changes.push({text:'Essence', attr: 'essence', old: original.essenceCode, new: data.essence });
    }
    return changes;
  }

  ngOnInit() {
    console.log('pilesaver',{original: this.original,data:this.data, ch:this.changed})
  }

  save(){



    this.modalController.dismiss({
      confirmed:true
    });
  }
  cancel() {
    this.modalController.dismiss({
      confirmed:false
    });
   }

}
